export default __webpack_public_path__ + "static/media/loading-doge.6dcae6ea.gif";